<template>
	<svg
		class="dot-loader-svg"
		version="1.1"
		id="L4"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		enable-background="new 0 0 0 0"
		xml:space="preserve"
		:width="width"
		:height="height"
	>
		<circle
			:fill="color"
			stroke="none"
			cx="5"
			cy="9"
			r="3"
		>
			<animate
				attributeName="opacity"
				dur="1s"
				values="0;1;0"
				repeatCount="indefinite"
				begin="0.1"
			/>
		</circle>
		<circle
			:fill="color"
			stroke="none"
			cx="20"
			cy="9"
			r="3"
		>
			<animate
				attributeName="opacity"
				dur="1s"
				values="0;1;0"
				repeatCount="indefinite"
				begin="0.2"
			/>
		</circle>
		<circle
			:fill="color"
			stroke="none"
			cx="35"
			cy="9"
			r="3"
		>
			<animate
				attributeName="opacity"
				dur="1s"
				values="0;1;0"
				repeatCount="indefinite"
				begin="0.3"
			/>
		</circle>
	</svg>
</template>

<script>
export default {
	name: 'DotLoader',
	props: {
		width: {
			type: Number,
			default: 100
		},
		height: {
			type: Number,
			default: 18
		},
		color: {
			type: String,
			default: '#000'
		}
	}
};
</script>

<style lang="less">
	.dot-loader-svg {
		width: 100%;
		height: auto;
		display: inline-block;
	}
</style>